/* Chile: "Pedido real" entra só no pedido final, numa linha própria.
   Não pode usar o prefixo upsell_: o Releasit trata isso como oferta
   pós-compra e a oferta seguinte deixa de ir no pedido. */
(function () {
  'use strict';

  var VARIANT_ID = '67543745954020';
  var VARIANT_NAME = 'item_variant_id[real_order]';
  var QUANTITY_NAME = 'item_quantity[real_order]';
  var OLD_KEY = 'upsell_15351369269476';

  function isMarker(field) {
    if (!field || !field.name) return false;
    var name = String(field.name);
    var value = String(field.value || '');
    return name.indexOf('real_order') !== -1 ||
      name.indexOf(OLD_KEY) !== -1 ||
      (name.indexOf('item_variant_id[') === 0 && value === VARIANT_ID);
  }

  function ensure(formData) {
    if (!Array.isArray(formData)) return;
    for (var index = formData.length - 1; index >= 0; index -= 1) {
      if (isMarker(formData[index])) formData.splice(index, 1);
    }
    formData.push({ name: VARIANT_NAME, value: VARIANT_ID });
    formData.push({ name: QUANTITY_NAME, value: '1' });
  }

  function strip(formData) {
    if (!Array.isArray(formData)) return;
    for (var index = formData.length - 1; index >= 0; index -= 1) {
      if (isMarker(formData[index])) formData.splice(index, 1);
    }
  }

  var previousHook = window._COD_FORM_OVERWRITE_ON_SUBMIT_START;
  window._COD_FORM_OVERWRITE_ON_SUBMIT_START = function (formData) {
    if (typeof previousHook === 'function' && previousHook(formData) === false) return false;
    return true;
  };

  function patchPayload(url, body) {
    var target = String(url || '');
    if (target.indexOf('create-order') === -1) return body;
    if (typeof body !== 'string' || body.charAt(0) !== '{') return body;
    var payload;
    try {
      payload = JSON.parse(body);
    } catch (error) {
      return body;
    }
    if (!payload || !Array.isArray(payload.formData)) return body;
    if (target.indexOf('is_abandoned_') !== -1) strip(payload.formData);
    else ensure(payload.formData);
    return JSON.stringify(payload);
  }

  if (typeof navigator.sendBeacon === 'function' && !navigator.sendBeacon.__svRealOrder) {
    var nativeBeacon = navigator.sendBeacon.bind(navigator);
    var beacon = function (url, data) {
      return nativeBeacon(url, patchPayload(url, data));
    };
    beacon.__svRealOrder = true;
    navigator.sendBeacon = beacon;
  }

  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function' && !nativeFetch.__svRealOrder) {
    window.fetch = function (input, init) {
      var args = Array.prototype.slice.call(arguments);
      try {
        var url = typeof input === 'string' ? input : input && input.url;
        if (init && typeof init.body === 'string') {
          args[1] = Object.assign({}, init, { body: patchPayload(url, init.body) });
        }
      } catch (error) {}
      return nativeFetch.apply(this, args);
    };
    window.fetch.__svRealOrder = true;
  }

  var nativeSend = XMLHttpRequest.prototype.send;
  if (!nativeSend.__svRealOrder) {
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (typeof body === 'string' && this.__svRealOrderUrl) body = patchPayload(this.__svRealOrderUrl, body);
      } catch (error) {}
      return nativeSend.call(this, body);
    };
    XMLHttpRequest.prototype.send.__svRealOrder = true;
    var nativeOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__svRealOrderUrl = url;
      return nativeOpen.apply(this, arguments);
    };
  }
})();
